import { Category } from "./category.model"
export class SaleableSeat {
	id: string
	category: Category
	saleableSeatState: string
}



// WEBPACK FOOTER //
// ./src/app/models/saleable-seat.model.ts